{
  "common": {
    "show": "Tonen",
    "about": "Over",
    "newPost": "Nieuw bericht",
    "active": "Actief",
    "change": "Wijzigen",
    "remove": "Verwijderen",
    "cancel": "Annuleren",
    "publish": "Publiceren",
    "save": "Opslaan",
    "draft": "Concept",
    "scheduled": "Ingepland",
    "published": "Gepubliceerd",
    "actions": "Acties",
    "archive": "Archiveren",
    "delete": "Verwijderen",
    "edit": "Bewerken",
    "edited": "Bewerkt",
    "settings": "Instellingen",
    "signUp": "Registeren",
    "by": "Door",
    "for": "voor",
    "you": "U",
    "one": "één",
    "option": "Optie ",
    "registered": "Geregistreerd",
    "to": "naar",
    "allEvents": "Alle gebeurtenissen",
    "placeholder": "plaatshouder",
    "percentOf": "% van",
    "private": "Privé",
    "updatedOn": "Bijgewerkt op",
    "blogPost": "Blogpost",
    "category": "Categorie",
    "author": "Auteur",
    "status": "Status",
    "errors": "Fouten",
    "all": "Alle",
    "archived": " Gearchiveerd",
    "back": "Terug",
    "restore": "Herstel deze versie",
    "next": "Volgende",
    "previous": "Vorige",
    "continue": "Doorgaan",
    "continueButton": "Doorgaan",
    "paid": "Betaald",
    "free": "Gratis",
    "uploadImagesVideos": "Afbeeldingen/video's uploaden",
    "upload": "Uploaden",
    "add": "Toevoegen",
    "on": "Aan",
    "from": "van",
    "members": "leden",
    "visibility": "Zichtbaarheid",
    "public": "Openbaar",
    "description": "Beschrijving",
    "managedBy": "Beheerd door",
    "noManagers": "Geen managers",
    "noDescription": "Geen beschrijving",
    "more": "meer",
    "moreCaps": "Meer",
    "less": "minder",
    "and": "en",
    "in": "in",
    "allSet": "Alles staat klaar!",
    "createdBy": "Gemaakt door",
    "home": "Startpagina",
    "selected": "Geselecteerd",
    "groupMembers": "Groepsleden",
    "everyone": "Iedereen",
    "manager": "Manager",
    "leave": "Vertrekken",
    "membersList": "Ledenlijst",
    "findChannelManagers": "Kanaalmanagers vinden",
    "searchGroupMembers": "Groepsleden zoeken",
    "searchMembers": "Leden zoeken",
    "searchMember": "Lid zoeken",
    "enterDescription": "Beschrijving invoeren",
    "apply": "Aanmelden",
    "selectRole": "Rol selecteren",
    "people": "Mensen",
    "viewProfile": "Profiel bekijken",
    "leaderboard": "Leaderboard",
    "events": "Gebeurtenissen",
    "logOut": "Uitloggen",
    "topLevelReached": "Bovenste niveau bereikt",
    "topLevelReachedExclaim": "Hoogste niveau bereikt!",
    "congratsTopLevel": "Gefeliciteerd! U hebt het hoogste niveau bereikt!",
    "share": "Delen",
    "copyLink": "Link kopiëren",
    "reply": "Antwoorden",
    "download": "Downloaden",
    "noPreviewAvailable": "Geen voorbeeldweergave beschikbaar",
    "userNotFound": "Gebruiker niet gevonden",
    "userNotFoundMessage": "Gebruiker niet gevonden",
    "thisGroupIsPrivate": "Deze groep is privé",
    "unableToPreviewPdf": "Voorbeeldweergave van het PDF-bestand is nu niet beschikbaar. Download om het te bekijken.",
    "failedToDownloadPdf": "PDF-bestand downloaden mislukt",
    "notifyAll": "Breng iedereen in het kanaal op de hoogte",
    "communities": "Community's",
    "courses": "Cursussen",
    "affiliates": "Partners",
    "chats": "Chat",
    "switchToDarkMode": "Overschakelen naar donkere modus",
    "switchToLightMode": "Overschakelen naar lichte modus",
    "editProfile": "Profiel bewerken",
    "account": "Account",
    "logout": "Uitloggen",
    "noResults": "Geen resultaten",
    "confirmPayment": "Betaling bevestigen",
    "done": "Voltooid",
    "manage": "BEHEREN",
    "copied": "Gekopieerd",
    "submit": "Verzenden",
    "request": "Verzoek",
    "approve": "Goedkeuren",
    "decline": "Afwijzen",
    "comingSoon": "Binnenkort beschikbaar",
    "detailsUpdatedSuccessfully": "Details zijn bijgewerkt",
    "oopsUnableToSaveDetails": "Oeps! Kan details niet opslaan.",
    "verificationFailedPleaseTryAgain": "Verificatie mislukt! Probeer het opnieuw",
    "loading": "Aan het laden",
    "title": "Titel",
    "addLink": "Link toevoegen",
    "writeHere": "Schrijf hier",
    "copy": "Kopiëren",
    "reset": "Herstellen",
    "register": "Inschrijven",
    "search": "Zoeken",
    "confirm": "Bevestigen",
    "success": "Succes",
    "toReview": "Naar Review",
    "invite": "Invite",
    "contributions": "Bijdragen",
    "communitiesSettings": "Instellingen voor Community's",
    "create": "Maken",
    "name": "Naam",
    "linkCopied": "Link Copied!",
    "move": "Verplaatsen",
    "irreversible": "onomkeerbaar",
    "close": "Sluiten",
    "greeting": "Hallo, {name}!",
    "managePayments": "Manage Payments",
    "manageYourAccount": "Manage uw Account",
    "accountSettings": "Account Settings",
    "proceed": "Doorgaan",
    "uploading": "Uploaden",
    "retry": "Probeer het opnieuw",
    "login": "Inloggen",
    "follow": "Volgen",
    "following": "Volgend",
    "followers": "Volgers",
    "view": "BEKIJKEN",
    "selectAnOption": "Selecteer een optie",
    "channels": "Platforms",
    "somethingWentWrong": "Er is iets misgegaan. Probeer het opnieuw.",
    "switchToNormalMode": "Overschakelen naar de normale modus",
    "switchToReadingMode": "Overschakelen naar leesmodus",
    "goToHomepage": "Gan naar de startpagina",
    "onlyGroupOwnersCanCreateCourses": "Alleen groepseigenaren kunnen nieuwe cursussen maken",
    "createGroup": "Groep aanmaken",
    "discover": "Ontdekken",
    "continuePayment": "Doorgaan met betalen",
    "invalidCredentials": "U heeft een ongeldig e-mailadres of wachtwoord ingevoerd. Probeer het opnieuw.",
    "comingUpEvents": "Aankomende gebeurtenissen!",
    "integratePaymentGateway": "Betalingsgateway integreren",
    "connectPaymentGateway": "Sluit een nieuwe betalingsgateway aan of beheer uw bestaande.",
    "isLive": "is live",
    "justNow": "Zojuist",
    "likes": "Vind-ik-leuks",
    "accessRequired": "Toegang*",
    "zeroProgress": "0",
    "noFollowersTitle": "Het lijkt erop dat niemand u volgt.",
    "noFollowersSubtext": "Voeg uw connectie toe aan de volglijst",
    "noFollowingTitle": "U volgt nog niemand.",
    "noFollowingSubtext": "Begin mensen te volgen om hun posts te zien",
    "followBack": "Terugvolgen",
    "logIn": "INLOGGEN",
    "video": "Video",
    "audio": "Audio",
    "newVersionAvailable": "Er is een nieuwe versie van de app beschikbaar. Update om deze functie te gebruiken!",
    "ariaLabels": {
      "backButton": "Terugknop",
      "openEventLocation": "Locatie voor gebeurtenis openen",
      "editEvent": "Gebeurtenis bewerken",
      "deleteEvent": "Gebeurtenis verwijderen",
      "cancelRsvp": "RSVP annuleren",
      "publicGroupRadio": "Keuzerondje openbare groep",
      "privateGroupRadio": "Radioknop voor privégroep",
      "accessibleFromSwitcherCheckbox": "Toegankelijk via switcher selectievakje",
      "allowMembersToInviteCheckbox": "Selectievakje leden toestaan om uit te nodigen",
      "addMembers": "Leden toevoegen",
      "settings": "Instellingen",
      "leaveChannel": "Kanaal verlaten",
      "channelSettings": "Kanaalinstellingen",
      "selectRole": "Rol selecteren",
      "deleteChannel": "Kanaal verwijderen",
      "changeToPrivateChannel": "Wijzigen in privékanaal",
      "allowMembersToPosts": "Leden toestaan om berichten te plaatsen",
      "restrictMembersFromPosts": "Leden beperken in het verzenden van berichten",
      "close": "Sluiten",
      "open": "Openen",
      "more": "Meer",
      "upload": "Uploaden",
      "play": "Afspelen",
      "pause": "Onderbreken",
      "mute": "Dempen",
      "unmute": "Dempen opheffen",
      "fullscreen": "Volledig scherm",
      "exitFullscreen": "Volledig scherm afsluiten",
      "download": "Downloaden",
      "share": "Delen",
      "like": "Vind ik leuk",
      "comment": "Opmerking",
      "reply": "Antwoord",
      "pin": "Pin",
      "unpin": "Losmaken",
      "report": "Rapport",
      "copyLink": "Link kopiëren",
      "embedCode": "Insluitcode",
      "previewImage": "Voorbeeld afbeelding",
      "profileImage": "Profielafbeelding",
      "coverImage": "Omslagafbeelding",
      "thumbnail": "Miniatuur",
      "attachment": "Bijlage",
      "removeAttachment": "Bijlage verwijderen",
      "uploadFile": "Bestand uploaden",
      "selectFile": "Bestand selecteren",
      "searchIcon": "Zoekpictogram",
      "menuIcon": "Menu-icoon",
      "notification": "Melding",
      "messages": "Berichten",
      "profile": "Profiel",
      "logout": "Uitloggen",
      "send": "Verzenden",
      "cancel": "Annuleren",
      "submit": "Verzenden",
      "next": "Volgende",
      "previous": "Vorige",
      "refresh": "Vernieuwen",
      "filter": "Filteren",
      "sort": "Sorteren",
      "view": "Bekijken",
      "expand": "Uitvouwen",
      "collapse": "Samenvouwen",
      "downloadFile": "Document downloaden",
      "closeModal": "Venster afsluiten",
      "addMedia": "Media toevoegen",
      "lightModeRadio": "Keuzerondje lichte modus",
      "darkModeRadio": "Keuzerondje donkere modus",
      "communityThemeRadio": "Community Thema Keuzerondje",
      "userProfile": "Gebruikersprofiel",
      "postActions": "Acties plaatsen",
      "chatWindow": "Chatvenster",
      "chatActions": "Chatacties",
      "minimizeChat": "Chat minimaliseren",
      "closeChat": "Chat sluiten",
      "commentActions": "Opmerking acties",
      "replyToComment": "Op opmerking reageren",
      "groupLogo": "Groepslogo",
      "pinGroupIcon": "Pictogram van groep vastpinnen",
      "appSwitcher": "App Switcher",
      "communities": "Community's",
      "courses": "Cursussen",
      "search": "Zoeken",
      "giphyLogo": "Logo Giphy",
      "backToConversations": "Terug naar gesprekken",
      "commentAttachments": "Commentaarbijlagen",
      "tabSwitcher": "Tabbladwisselaar",
      "eventCover": "Omslag gebeurtenis",
      "eventCoverPreview": "Voorbeeld omslag gebeurtenis",
      "selectPaidEvent": "Betaalde gebeurtenis selecteren",
      "selectFreeEvent": "Gratis evenement selecteren",
      "selectCurrency": "Selecteer een valuta",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Venster beoordeling lidmaatschapsantwoorden sluiten",
      "liveStream": "Livestream",
      "openGroupMembers": "Groepsleden openen",
      "communityBanner": "Communitybanner",
      "home": "Startpagina",
      "mentionItem": "Vermeld item",
      "back": "Terug",
      "viewGroup": "Groep weergeven",
      "invitationIcon": "Uitnodigingspictogram",
      "openUserProfile": "Gebruikersprofiel openen",
      "closeStream": "Stroom sluiten",
      "groupAvatar": "Groepsavatar",
      "bannerImage": "Bannerafbeelding",
      "avatarImage": "Avatar afbeelding",
      "userAvatar": "Avatar van de gebruiker",
      "eventImage": "Afbeelding gebeurtenis",
      "postImage": "Afbeelding plaatsen",
      "channelIcon": "Kanaalpictogram",
      "groupIcon": "Groepssymbool",
      "communityIcon": "Community-pictogram",
      "memberAvatar": "Avatar van lid",
      "creatorAvatar": "Avatar van de maker",
      "authorAvatar": "Avatar auteur",
      "aboutFeaturedPost": "Over uitgelicht bericht",
      "accountSettings": "Accountinstellingen",
      "addChannel": "Kanaal toevoegen",
      "addCourse": "Cursus toevoegen",
      "addEmoji": "Emoji toevoegen",
      "affiliates": "Partners",
      "announceEvents": "Evenementen aankondigen",
      "avatar": "Avatar",
      "badge": "Badge",
      "camera": "Camera",
      "cardImage": "Kaart afbeelding",
      "categoryName": "Categorienaam",
      "channelList": "Kanaallijst",
      "channelSelect": "Kanaal selecteren",
      "chatAttachment": "Chatbijlage",
      "chats": "Chats",
      "closeCourseDetails": "Cursusgegevens sluiten",
      "closeLoginModal": "Aanmeldvenster sluiten",
      "closeMembershipQuestionsModal": "Venster met vragen aan leden sluiten",
      "closePaymentModal": "Betalingsvenster sluiten",
      "commentCard": "Kaart opmerking",
      "communityTheme": "Thema community",
      "conversationItem": "Gespreksonderdeel",
      "conversationSuggestion": "Gesprekssuggestie",
      "createChannel": "Kanaal maken",
      "customThemeRadio": "Aangepast Thema Keuzerondje",
      "deleteAnswerButton": "Antwoordknop verwijderen",
      "deleteFile": "Bestand verwijderen",
      "editLevelName": "Naam van het niveau bewerken",
      "editProfile": "Profiel bewerken",
      "enterEmailAddress": "Voer een e-mailadres in",
      "featuredIcon": "Pictogram Uitgelicht",
      "giveAdministrativePrivileges": "Administratieve privileges geven",
      "gokollabLogo": "Logo Gokollab",
      "icon": "Pictogram",
      "image": "Afbeelding",
      "likeContent": "Media Vind ik leuk",
      "link": "Link",
      "marketplaceGroupSlug": "Slug van marketplacegroep",
      "microphone": "Microfoon",
      "nextAttachment": "Volgende bijlage",
      "noEvents": "Geen gebeurtenissen",
      "noCommunitiesIllustration": "Geen illustratie community's",
      "noCoursesFound": "Geen cursussen gevonden",
      "noFollowers": "Geen volgers",
      "noFollowing": "Geen volgende",
      "noPostsFound": "Geen berichten gevonden",
      "notificationItem": "Meldingitem",
      "notificationsList": "Meldingenlijst",
      "openEmbeds": "Insluitingen openen",
      "openEmbedsDrawer": "Insluitingslade openen",
      "openEventColor": "Kleur gebeurtenis openen",
      "openEventDetails": "Details gebeurtenis openen",
      "permissionNeeded": "Machtiging nodig",
      "pointsAndLevels": "Punten & niveaus",
      "previousAttachment": "Vorige bijlage",
      "reactedUser": "Gereageerde gebruiker",
      "reward": "Beloning",
      "rewards": "Beloningen",
      "selectChannel": "Selecteer kanaal",
      "selectEventOption": "Evenementoptie selecteren",
      "selectIcon": "Selecteer pictogram",
      "selectTimezone": "Selecteer tijdzone",
      "showChannelIcons": "Kanaalpictogrammen tonen",
      "sidebarActionButton": "Actieknop zijbalk",
      "speaker": "Luidspreker",
      "text": "Tekst",
      "thisGroupIsPrivate": "Deze groep is privé",
      "toReview": "Te beoordelen",
      "toggleFeaturedPost": "Uitgelicht bericht in-/uitschakelen",
      "toggleRewardsOptions": "Opties voor beloningen in-/uitschakelen",
      "viewReplies": "Bekijk antwoorden",
      "courseThumbnail": "cursus-miniatuur",
      "moreManagers": "meer managers",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Wijzigen in openbaar kanaal",
      "showMandatoryInfoModal": "Toon verplicht selectievakje voor profielmodal"
    },
    "placeholders": {
      "groupName": "Groepsnaam",
      "groupSlug": "Slug groep",
      "url": "URL",
      "enterPrice": "Voer de prijs in",
      "enterName": "Voer een naam in",
      "enterEmail": "Voer e-mail in",
      "selectTimezone": "Selecteer tijdzone",
      "selectChannel": "Selecteer kanaal",
      "enterSkoolGroupUrl": "De groeps-URL van uw Skool invoeren"
    },
    "email": "E-mail",
    "errorLoadingConversations": "Fout bij het laden van gesprekken",
    "noConversations": "Geen gesprekken"
  },
  "imageUpload": {
    "cropYourAvatar": "Uw avatar bijsnijden",
    "dragToReposition": "Slepen om te verplaatsen",
    "ariaLabels": {
      "imageUploader": "Uploader afbeelding",
      "avatar": "Avatar",
      "clearFile": "Wis bestand",
      "removeAvatar": "Avatar verwijderen",
      "zoomButton": "Zoomknop"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Video uploaden",
    "addVideoUsingLink": "Video toevoegen via een link",
    "uploadImage": "Afbeelding uploaden",
    "addVideo": "Video toevoegen"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Uw profiel voltooien",
    "profileIntentMessage1": "Community's zijn ongezellig zonder gezichten en namen.",
    "profileIntentMessage2": "Profielen zorgen voor vertrouwen en verbinding met anderen",
    "complete": "VOLTOOIEN",
    "recommendedAspectRatio": "Upload een {types}. Recommended Appearance Percentage 1:1",
    "addBio": "Voeg een bio toe ... (optioneel)"
  },
  "validations": {
    "nameRequired": "Naam is vereist!",
    "invalidDescription": "Ongeldige beschrijving!"
  },
  "payment": {
    "recurringWithTrial": "Na afloop van de proefperiode wordt er {currencySymbol} {price} per {interval} in rekening gebracht en u kunt op elk moment opzeggen.",
    "recurring": "{currencySymbol} {price} per {interval} met de mogelijkheid om op elk moment op te zeggen.",
    "oneTime": "{currencySymbol} {price} {paymentText}",
    "defaultOneTimeText": "eenmalige prijs voor het lidmaatschap.",
    "totalAmount": "Totaalbedrag",
    "trialDays": "Proefperiode van {days} dagen",
    "securePayments": "100% veilige en betrouwbare betalingen",
    "allowToChargeCard": "Door uw kaartgegevens te verstrekken, staat u toe dat {locationName} het bedrag op de creditcard in rekening brengt voor toekomstige betalingen overeenkomstig hun voorwaarden.",
    "paymentSuccessful": "Betaling geslaagd!"
  },
  "channel": {
    "notifications": {
      "managersEdited": "Managers succesvol bewerkt!",
      "managersAdded": "Managers succesvol toegevoegd!",
      "managersAddedToChannel": "managers toegevoegd aan",
      "membersAdded": "Leden zijn toegevoegd!",
      "memberPostingEnabled": {
        "title": "Succesvol Updated Members posten",
        "content": "Members is Enabled"
      },
      "roleUpdated": "Rol geüpdatet!",
      "updatedRoleOf": "Geüpdatete rol van {name}",
      "userRemoved": "Gebruiker succesvol verwijderd!",
      "removedUserFrom": "{name} uit {channelName} verwijderd",
      "errorOccurred": "Er is een fout opgetreden",
      "updated": {
        "title": "Kanaalinstellingen bijgewerkt",
        "contentPrivate": "Kanaal {channelName} is nu privé",
        "contentPublic": "Kanaal {channelName} is nu openbaar",
        "content": ""
      },
      "deleted": {
        "title": "Kanaal succesvol verwijderd",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Leden zijn toegevoegd!",
        "content": "{count} leden toegevoegd aan {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Managers zijn toegevoegd!",
        "content": "{count} managers zijn toegevoegd aan {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Succesvol Updated Members posten",
        "content": "Members is Disabled"
      },
      "visibilityChangedToPublic": "Kanaal {channelName} is nu openbaar",
      "visibilityChangedToPrivate": "Kanaal {channelName} is nu privé",
      "created": {
        "title": "Nieuw kanaal gemaakt",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Kanaal aanmaken mislukt",
          "content": "Probeer het later opnieuw"
        },
        "updateFailed": {
          "title": "Kanaal updaten mislukt",
          "content": "Probeer het later opnieuw"
        },
        "managersEditedFailed": {
          "title": "Het updaten van managers is mislukt!",
          "content": ""
        },
        "addFailed": {
          "title": "Het toevoegen van managers is mislukt!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Het toevoegen van leden is mislukt!",
          "content": ""
        }
      }
    },
    "createChannel": "Kanaal Create",
    "updateChannel": "KANAAL BIJWERKEN",
    "addMembers": "Leden toevoegen",
    "addManagers": "Managers toevoegen",
    "typeToAddMoreMembers": "Typ om meer leden toe te voegen",
    "examplePlaceholder": "ex. John of Jane",
    "makeChannelManager": "Kanaalmanager maken",
    "removeFromChannelManager": "Verwijderen als kanaalmanager",
    "manager": "Manager",
    "channelManager": "Kanaalmanager",
    "noMembersFound": "Geen leden gevonden.",
    "noManagersFound": "Geen managers gevonden.",
    "removeChannelMember": "Kanaallid verwijderen",
    "removeConfirmationMessage": "Weet u zeker dat u wilt verwijderen",
    "makeManagerConfirmationMessage": "Weet u zeker dat u",
    "makeManagerConfirmationMessage2": "kanaalmanager wil maken in",
    "channelName": "Kanaalnaam",
    "channelIcon": "Kanaalpictogram",
    "addChannel": "Kanaal toevoegen",
    "editChannel": "Kanaal Edit",
    "announcementChannel": "NOTICE Kanaal",
    "noChannelsAvailable": "Geen kanalen beschikbaar",
    "makeChannelPrivate": "Kanaal privé maken",
    "makeChannelPrivateMessage": "Beperk de toegang van leden tot alle kanaaldiscussies en -interacties.",
    "readOnlyChannel": "Alleen kanaal Read",
    "readOnlyChannelMessage": "Members kan IMPORTANT informatie en updates View , maar alleen beheerders/eigenaars of het kanaal kunnen dit Share .",
    "createPrivateChannel": "Maak dit kanaal privé",
    "createPrivateChannelMessage": "Alleen uitgenodigde Members . Non Members ziet deze Room niet",
    "allowMembersToPost": "Members to Share Enable",
    "allowMembersToPostMessage": "Deze optie Enable Members to Create Berichten en feedback inschakelen",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Door Members posting in te schakelen , Members to Create en Share -berichten binnen het kanaal Enable .",
      "mainMessage2": "Zorg ervoor dat every Members op de hoogte is of de new geplaatste Permissions.",
      "pointer1": "Deze Action kan op elke Date worden teruggedraaid.",
      "pointer2": "every berichten Created By Members is zichtbaar voor Everyone in het kanaal."
    },
    "privateChannelTooltip": "U heeft geen toegang tot dit kanaal",
    "restrictMembersFromPosting": "Members From posting beperken",
    "restrictMembersFromPostingMessage": "Door deze optie in Disable , wordt voorkomen dat Members From Created Of berichten en feedback binnen het kanaal bewerkt.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Het plaatsen van Members wordt Disable door every Members From Created en het delen van berichten binnen het kanaal te beperken.",
      "mainMessage2": "Zorg ervoor dat every Members op de hoogte is of de beperkingen voor het plaatsen van new berichten.",
      "pointer1": "Deze Action kan op elke Date worden teruggedraaid.",
      "pointer2": "every berichten Created By Members For this Change blijft voor Everyone zichtbaar in het kanaal."
    },
    "deleteChannel": "Kanaal verwijderen",
    "deleteChannelMessage": "Als u het kanaal verwijdert, gaan alle bijbehorende statistieken definitief verloren.",
    "deleteChannelMessageWithCourse": "Als je het kanaal verwijdert, gaan every Members -gegevens permanent verloren en alle Courses die aan dit kanaal zijn gekoppeld, worden Public, tenzij You ze eerst verwijdert.",
    "editChannelName": "Kanaalnaam bewerken",
    "editChannelDescription": "Kanaalbeschrijving bewerken",
    "channelNamePlaceholder": "bijv. Marketingrapporten",
    "editManagers": "Managers bewerken",
    "channelManagers": "Kanaalmanagers",
    "leaveChannel": "Kanaal verlaten",
    "leaveChannelConfirmation": "Weet You zeker dat You dit kanaal wilt Leave ?",
    "changeToPrivateChannel": "Kanaal privé maken",
    "changeToPrivateChannelMessage": "Door het kanaal privé te maken, wordt het gebruik van het kanaal voor interacties en discussies beperkt tot alleen leden.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Door dit kanaal over te schakelen naar Private , heeft u alleen SLOTMAX Access to Selected Members en managers.",
      "mainMessage2": "Vergeet niet om every gewenste Members Add aan je Private kanaal.",
      "pointer1": "Deze Action is",
      "pointer2": "new Members die aan kanaal is toegevoegd, heeft Access tot every PAST discussies en interacties binnen het kanaal."
    },
    "changeToPublicChannel": "Maken platform Openbaar",
    "changeToPublicChannelMessage": "Door het kanaal openbaar te maken, kunnen alle groepsleden dit kanaal bekijken en eraan deelnemen.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Als u dit platform openbaar maakt, wordt het Openbaar voor Iedereen community Leden.",
      "mainMessage2": "Iedereen van de Groep Leden zal dit platform kunnen Bekijken en eraan meedoen.",
      "pointer1": "Iedereen van de community Leden zal automatisch Inloggen hebben tot dit platform.",
      "pointer2": "VERLEDEN privé platform media zal zichtbaar worden voor alle leden van de groep."
    },
    "publicChannel": "Openbaar kanaal",
    "peopleWhoCanManage": "Mensen die kunnen beheren",
    "addChannelHelperText": "Show More community: Add -kanalen voor diverse discussies, Duet en verbinding.",
    "privateChannel": "Privékanaal",
    "removeFromChannel": "Uit kanaal verwijderen",
    "removeConfirmationMessage2": "Van dit platform",
    "findChannelManagers": "Kanaalmanagers vinden",
    "removeChannelManager": "Kanaalmanager verwijderen",
    "irreversible": "Deze actie kan niet ongedaan worden gemaakt."
  },
  "chat": {
    "unblockUser": "Gebruiker deblokkeren",
    "blockUser": "Gebruiker blokkeren",
    "blockMessage1": "U kunt geen berichten meer sturen naar deze gebruiker.",
    "blockMessage2": "Dit account wordt niet geblokkeerd in de groep. Mogelijk kunt u hun posts, opmerkingen en reacties nog steeds zien.",
    "deleteChat": "Chat verwijderen",
    "deleteChatMessage": "Weet u zeker dat u dit gesprek wilt verwijderen?",
    "block": "Blokkeren",
    "conversation": "gesprek",
    "youPrefix": "U: ",
    "messageNotSent": "Dit bericht is niet verzonden",
    "sending": "Verzenden",
    "youAndUserKnowEachOther": "U en {name} kennen elkaar",
    "startConversationWithHi": "Begin een gesprek door \"Hallo\" te verzenden",
    "accountSettings": "Accountinstellingen",
    "blockedUserMessage": "U hebt { name } geblokkeerd. U kunt geen berichten verzenden of ontvangen. Deblokkeer deze persoon om een gesprek te beginnen. Om uw lijst met geblokkeerde gebruikers te bekijken, gaat u naar uw",
    "blockRecipientMessage": "{ name } heeft u geblokkeerd. U kunt geen berichten uploaden of ontvangen.",
    "nothingFound": "Niets gevonden!",
    "pleaseCheckUsername": "Controleer de gebruikersnaam en probeer het opnieuw",
    "startChatting": "Begin met chatten",
    "noChatYet": "Het lijkt erop dat u nog met niemand heeft gechat.",
    "noChatYetMessage": "Zoek een contactpersoon en zet de eerste stap!",
    "noConversationsFound": "Geen gesprekken gevonden",
    "searchMembersAndStartChatting": "Zoek leden en begin met chatten",
    "cannotMessageDeletedUser": "You kunt geen berichten Upload naar een Deleted Operator",
    "message": "Bericht",
    "media": "Media",
    "files": "Bestanden"
  },
  "comments": {
    "reportComment": "Een opmerking melden",
    "reportCommentMessage": "Weet u zeker dat u deze opmerking wilt melden?",
    "deleteComment": "Commentaar verwijderen",
    "editComment": "Commentaar bewerken",
    "loadMoreReplies": "Meer antwoorden laden",
    "deleteCommentMessage": "Weet u zeker dat u deze opmerking wilt verwijderen?",
    "writeComment": "Een opmerking schrijven",
    "comment": "OPMERKING",
    "cancel": "ANNULEREN",
    "save": "BESPAREN",
    "replyingTo": "Antwoord sturen aan",
    "newComment": "new opmerking",
    "latest": "Laatste",
    "onlyAdminsCanComment": "Alleen community kunnen in dit kanaal reageren.",
    "isCommentDisabledForPost": "Er kunnen geen reacties worden geplaatst op dit bericht.",
    "isCommentDisabledErrorContent": "De Editor Of de Groep Admin heeft feedback op dit Delen Uitgeschakeld Via.",
    "isCommentDisabledErrorTitle": "feedback Uitgeschakeld"
  },
  "embeds": {
    "uploadImage": "Afbeelding uploaden",
    "addYoutubeVimeoLoomLink": "Een link naar Youtube, Vimeo of Loom toevoegen",
    "uploadAttachment": "PDF-, CSV- of XLSX-bestanden uploaden",
    "addAttachment": "Bijlage toevoegen",
    "allowedTypes": "SVG, PNG, JPG of GIF (max. 800x400px)",
    "placeholder": "Een link naar Youtube, Vimeo of Loom toevoegen",
    "uploadVideo": "Video uploaden/koppelen",
    "uploadVideoPlaceholder": "Een link naar Youtube, Vimeo of Loom toevoegen",
    "uploadVideoAllowedTypes": "Een MP4-videobestand uploaden",
    "addEmoji": "Emoji toevoegen",
    "emojiSuggestion": "Opent Emoji-kiezer",
    "addGif": "GIF toevoegen",
    "gifSuggestion": "Opent GIF-kiezer",
    "addImage": "Afbeelding toevoegen",
    "imageSuggestion": "Opent uw galerij",
    "addVideo": "Video toevoegen",
    "videoSuggestion": "Opent uw galerij",
    "selectFile": "Bestand selecteren",
    "attachmentSuggestion": "Opent bestandsmanager",
    "takePhoto": "Maak een foto",
    "uploadPhotoVideo": "Foto/video uploaden",
    "limitExceeded": "Limiet overschreden",
    "limitExceededMessage": "U kunt niet meer dan 4 bestanden bijvoegen",
    "errorWhileUploadingFile": "Fout tijdens uploaden bestand! Probeer het opnieuw",
    "clickToUpload": "Klik om te uploaden",
    "orDragAndDrop": "of slepen en neerzetten",
    "validUrl": "Er is een geldige URL nodig",
    "enterSomeText": "Voer wat tekst in",
    "addLink": "Link toevoegen",
    "text": "Tekst",
    "addVideoLink": "Of, Add a YouTube, Vimeo, Loom, Of Wistia Video Link.",
    "uploadVideoAndImages": "Video's en afbeeldingen Upload",
    "recommendedAspectRatio": "Recommended Appearance Percentage {ratio}",
    "addHashtag": "Label kanalen, gevallen en cursussen",
    "hashtagSuggestion": "Hashtag Suggestie"
  },
  "tabSwitcher": {
    "discussion": "Discussie",
    "learning": "Leren",
    "members": "Leden",
    "people": "Mensen",
    "leaderboard": "Leaderboard",
    "channels": "Kanalen",
    "groups": "Groepen",
    "more": "Meer",
    "home": "Start",
    "discover": "Ontdekkenken",
    "courses": "Cursussen",
    "communities": "Community's"
  },
  "groupInfo": {
    "pinGroup": "Groep vastzetten",
    "unpinGroup": "Groep losmaken",
    "maxPinnedGroupsLimit": "Er kunnen slechts maximaal 4 Group worden vastgemaakt",
    "publicGroup": "Openbare groep",
    "privateGroup": "Privégroep",
    "coverImage": "Omslag groep",
    "members": "Leden",
    "posts": "Posts",
    "admin": "Admin",
    "settings": "INSTELLINGEN",
    "inviteMembers": "LEDEN UITNODIGEN",
    "answerQuestions": "Vragen beantwoorden",
    "toJoin": "om lid te worden van {name}",
    "changeRole": "Rol wijzigen",
    "removeFromGroup": "Uit de groep verwijderen",
    "contributor": "Bijdrager",
    "membershipAnswers": "Antwoorden over lidmaatschap",
    "unbanMember": "Lid van Unban",
    "banFromGroup": "Toegang tot groep ontzeggen",
    "requestedOn": "Aangevraagd op",
    "invitedOn": "Uitgenodigd op",
    "joinedOn": "Lid geworden",
    "noMembersFound": "Geen leden gevonden.",
    "youAreAllCaughtUp": "Je every bij - no Members here Right now!",
    "banUserConfirmation": "Weet u zeker dat u deze gebruiker de toegang tot de groep wilt ontzeggen?",
    "deleteContentCheckbox": "Verwijder every Content Created By deze Operator",
    "active": "Actief",
    "admins": "Admins",
    "contributors": "Bijdragers",
    "requested": "Aangevraagd",
    "banned": "Verboden",
    "invited": "Uitgenodigd",
    "paymentReceived": "Betaling ontvangen",
    "paymentInitiated": "Betaling geïnitieerd",
    "answeredQuestions": "Beantwoorde vragen",
    "answeredQuestionsMessage": "heeft de volgende vraag beantwoord om lid te worden van",
    "darkMode": "Donkere modus",
    "darkModeMessage": "Pas de stijl van de community aan om schittering te verminderen en uw ogen wat rust te gunnen.",
    "accessGranted": "Toegang verleend: begin uw educatieve avontuur.",
    "stepIntoAction": "Kom in actie! Laten we samenwerken en plezier maken.",
    "viewMembersAndMemberDetails": "Leden en details van leden bekijken",
    "reviewContentReportsAndMore": "Contentrapporten en meer bekijken",
    "toReview": "Te beoordelen",
    "switchToOtherGroups": "Overschakelen naar Other Group",
    "placeholders": {
      "yourAnswer": "Jouw antwoord"
    },
    "notifications": {
      "userBanned": "Toegang tot de groep ontzegd aan gebruiker",
      "somethingWentWrong": "Er is iets misgegaan. Probeer het later opnieuw."
    },
    "membershipSettings": "Lidmaatschapsinstellingen",
    "paymentFailed": "Betaling mislukt!",
    "paymentFailedMessage": "Betaling mislukt, uw verzoek om lid te worden van de groep is geweigerd.",
    "gamification": {
      "addRewards": "Beloningen toevoegen",
      "title": "Titel",
      "description": "Beschrijving toevoegen",
      "textbox": "Tekstvak",
      "singleSelect": "Enkelvoudige selectie",
      "multipleSelect": "Meervoudige selectie",
      "question": "Vraag",
      "validations": {
        "titleRequired": "Geef een titel op",
        "descriptionRequired": "Geef een beschrijving op",
        "somethingWentWrong": "Er is iets misgegaan. Probeer het later opnieuw.",
        "updatedRewards": "Bijgewerkte beloningen"
      },
      "settings": {
        "updatedRewards": "Bijgewerkte beloningen"
      }
    },
    "customCode": {
      "advanced": "Geavanceerd",
      "testPreview": "Testvoorbeeldweergave",
      "enableConfirmationMessage": "Alleen inschakelen als u de testvoorbeeldweergave heeft geverifieerd",
      "testPreviewMessage": "Er wordt een nieuw tabblad geopend met een testvoorbeeldweergave van uw community. U kunt dit gebruiken om te controleren of uw aangepaste code werkt.",
      "liveMode": "Live -modus",
      "customJS": "Custom JS",
      "customCSS": "Custom CSS",
      "trackingCode": "Tracking Code",
      "headerCode": "Code",
      "footerCode": "Footer Code"
    },
    "branding": {
      "brandYourGroup": "U kunt uw groep hier de branding van uw keuze meegeven",
      "updateBranding": "Branding bijwerken",
      "clickToUploadFavicon": "Klik om Favicon te uploaden",
      "dragAndDropFavicon": "Sleep een {types} (beeldverhouding 1:1)",
      "clickToUploadCover": "Klik om de cover te uploaden",
      "dragAndDropCover": "Sleep een {types} (beeldverhouding 16:9)",
      "clickToUploadLogo": "Klik om een groepslogo te uploaden",
      "dragAndDropLogo": "Sleep een {types} (beeldverhouding 1:1)",
      "aspectRatioMustBe1To1": "De beeldverhouding van de afbeelding moet 1:1 zijn.",
      "aspectRatioMustBe16To9": "De beeldverhouding van de afbeelding moet 16:9 zijn",
      "favicon": "Favicon",
      "coverImage": "Omslagafbeelding",
      "logo": "Logo",
      "invalidFileFormat": "Oeps! Ongeldig bestandsformaat/-type.",
      "pleaseUploadImageType": "Ondersteunde bestandstypen: {types}"
    },
    "groupAppearance": {
      "description": "You kunt uw Group Appearance per uw keuze Configure here",
      "slug": "Vernieuw je Group Appearance here",
      "colorMode": "Color",
      "previewTheLook": "Preview hoe je Group Appearance in de modus Light en Dark",
      "light": "Licht",
      "dark": "Donker",
      "communityTheme": "community Theme",
      "customTheme": "Custom Theme",
      "windowGradient": "Gradient Window",
      "applyGradientColorsToYourSidebarAndTopbar": "Apply Gradient -kleuren toe in je sidebar en topbar",
      "labels": {
        "sidebarBackground": "Achtergrond sidebar",
        "primary": "PRIMARY",
        "secondary": "Secundair",
        "tertiary": "Tertiair",
        "surface": "Surface",
        "fontPrimary": "PRIMARY Font",
        "fontSecondary": "Secundair lettertype",
        "fill": "Fill Color",
        "border": "Rand",
        "error": "Fout",
        "background": "Achtergrond",
        "option": "Optie"
      },
      "customThemes": {
        "default": "Standaard",
        "zestyCitrus": "Pittige Citrus",
        "royalVelvet": "Royal Velvet",
        "sunnyDelight": "Sunny Delight",
        "lushMeadow": "Lush Meadow",
        "azureDreams": "Azure Dreams",
        "bubblegumBliss": "Bubblegum Bliss",
        "ivoryWhisper": "Ivoor Whisper",
        "midnightDeep": "Middernacht"
      },
      "unsavedChanges": "Niet-opgeslagen Dynamic",
      "unsavedChangesMessage": "Je hebt niet-opgeslagen Theme Dynamic, Weet je zeker dat je de Dynamic Undo ?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Promotionele links",
      "createPromotionalLinkDescription": "Maak promotionele links voor uw groep",
      "addPromotionalLink": "Link toevoegen",
      "deleteLink": "Link verwijderen",
      "deleteLinkConfirmation": "Weet u zeker dat u deze link wilt verwijderen?",
      "labels": {
        "description": "Beschrijving",
        "url": "URL",
        "private": "Privé",
        "privateLinksDescription": "Privélinks zijn alleen zichtbaar voor groepsleden"
      },
      "placeholders": {
        "enterLinkDescription": "Een linkbeschrijving invoeren",
        "enterLinkURL": "Voer de link-URL in"
      },
      "addPromotionalLinkDescription": "Promotional Links Create voor je Group",
      "ariaLabels": {
        "editLink": "Link bewerken",
        "deleteLink": "Link verwijderen"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Vraag toevoegen",
      "editQuestion": "Vraag bewerken",
      "editLevelName": "Naam van het niveau bewerken",
      "addOption": "Optie toevoegen",
      "level": "Niveau",
      "name": "Naam",
      "addMembersQuestionsDescription": "Voeg ledenvragen toe die mensen moeten beantwoorden als ze toegang vragen tot uw groep",
      "enableMembershipQuestions": "Lidmaatschapsvragen inschakelen",
      "membershipQuestions": "Lidmaatschapsvragen",
      "deleteQuestion": "Vraag verwijderen",
      "deleteQuestionConfirmation": "Weet u zeker dat u deze vraag wilt verwijderen?",
      "labels": {
        "textBox": "Tekstvak",
        "singleSelect": "Enkelvoudige selectie",
        "multipleSelect": "Meervoudige selectie",
        "enableMembershipQuestions": "Add één Question tot Enable Membership vragen"
      },
      "validations": {
        "questionRequired": "Voer een vraag in",
        "answerOptionsRequired": "Minimaal twee opties vereist en ze moeten uniek zijn",
        "somethingWentWrong": "Er is iets misgegaan. Probeer het later opnieuw.",
        "updatedQuestions": "Bijgewerkte lidmaatschapsvragen voor groep",
        "levelNameRequired": "Voer de naam van het niveau in",
        "updatedLevelName": "Naam van het niveau bijgewerkt"
      },
      "placeholders": {
        "enterLevelName": "Naam van het niveau",
        "selectOne": "Selecteer één optie",
        "keepItShort": "Houd het kort ...",
        "exampleOffer": "bijv 10% Disabled On eerste aankoop"
      },
      "privacyNotice": "Ik begrijp dat mijn antwoorden Archive en zichtbaar zijn voor Group .",
      "ariaLabels": {
        "editQuestion": "Vraag bewerken",
        "deleteQuestion": "Vraag verwijderen"
      }
    },
    "gamificationAndRewards": {
      "title": "Niveaus en beloningen aanpassen",
      "description": "Namen van niveaus aanpassen en beloningen toevoegen voor meer betrokkenheid van leden",
      "gamification": "Gamification",
      "rewards": "Beloningen",
      "addRewards": "Beloning toevoegen",
      "ariaLabels": {
        "toggleGamification": "Gamification-opties in-/uitschakelen"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Uitnodiging succesvol verzonden",
      "invitationSentSuccessfullyDescription": "Uitnodiging verzonden naar {email}",
      "shareGroupLink": "Uw groepslink delen",
      "inviteMember": "Lid uitnodigen",
      "inviteMemberDescription": "Bouw aan uw community door een nieuw lid uit te nodigen",
      "inviteViaEmail": "Uitnodigen via e-mail",
      "invitedMembersWillBeAutoApproved": "Uitgenodigde leden worden automatisch goedgekeurd om lid te worden van de groep",
      "sendInvite": "UITNODIGING VERSTUREN",
      "permissionDenied": "You hebt geen Authorization om Members uit te nodigen. Contact op met uw beheerder.",
      "labels": {
        "giveAdministrativePrivileges": "Administratieve privileges geven",
        "giveAdministrativePrivilegesDescription": "Geef dit lid toestemming om alle administratieve activiteiten uit te voeren",
        "name": "Naam",
        "email": "E-mail",
        "nameLabel": "Naam",
        "emailLabel": "E-mail"
      },
      "placeholders": {
        "enterName": "Naam invoeren",
        "enterEmail": "E-mail invoeren"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Groepsdetails bijwerken",
      "updateGroupDetailsDescription": "Werk hier uw groepsdetails bij",
      "slugNotAvailable": "Slug van de groep niet beschikbaar",
      "description": "Licht de aard van de discussies die in de groep zullen plaatsvinden toe",
      "publicDescription": "Iedereen kan de groepsposts en andere leden van de groep zien",
      "privateDescription": "Alleen leden kunnen de groepsposts en andere leden van de groep zien",
      "accessibleFromSwitcher": "Toegankelijk via switcher",
      "accessibleFromSwitcherDescription": "Uw groep is zichtbaar voor niet-leden in de switcher",
      "allowMembersToInvite": "Members Enable om new Members uit te nodigen",
      "allowMembersToInviteDescription": "Hide de Invite Button voor Members When is Disabled. Members kan alleen Other If dit is Enabled uitnodigen.",
      "showMandatoryInfoModal": "Vereist profielmodal weergeven",
      "showMandatoryInfoModalDescription": "Wanneer ingeschakeld, worden leden gevraagd hun profielgegevens in te vullen wanneer ze zich aansluiten bij de groep.",
      "slug": "Slug van de groep",
      "discovery": {
        "title": "Ontdekking",
        "description": "Word ontdekt door miljoenen actieve gebruikers. De groep is zichtbaar op de ontdekkingspagina zodra u meer dan 10 leden heeft.",
        "discoverChannels": "Kanalen Discover",
        "joinGroupToExploreAllChannels": "join van de Group om every kanalen te verkennen",
        "categoryIsUsedOnlyOnGokollab": "Categorie wordt alleen gebruikt op Gokollab",
        "categoryAutomaticallySuggested": "De categorie wordt automatisch voorgesteld met behulp van AI op basis van de titel en beschrijving van uw groep. Voor de meest nauwkeurige suggestie moet u ervoor zorgen dat uw groepsgegevens duidelijk het doel en de onderwerpen weergeven.",
        "categoryRefreshLimited": "Het vernieuwen van de categorie is beperkt tot één keer per 24 uur"
      },
      "placeholders": {
        "description": "Een korte beschrijving invoeren"
      },
      "validations": {
        "nameRequired": "Voer een geldige groepsnaam in!",
        "slugRequired": "Voer een geldige slug voor de groep in!",
        "specialCharacterNotSupported": "Speciaal teken niet ondersteund",
        "descriptionRequired": "Groepsbeschrijving is vereist!",
        "emailRequired": "Voer een geldig e-mailadres in!",
        "fullNameRequired": "Voer een geldige naam in!"
      },
      "labels": {
        "groupName": "Group"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Manage je Subscription",
      "viewAndManageGroupSubscriptions": "Subscription van View and View Group",
      "paymentIntegrationMissingMessage": "Group betalingen in Location to Enable Paid",
      "price": "Prijs",
      "currency": "Valuta",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Eén Date",
      "priceDeletedAlert": "Payment Product is From Sync, click here om opnieuw te synchroniseren",
      "intervals": {
        "month": "Maand",
        "year": "Jaar",
        "week": "Week",
        "day": "Dag"
      },
      "addNewPrice": "Add Price",
      "editPrice": "Edit Price",
      "addPrice": "Add Price",
      "subscriptionType": {
        "recurring": "Terugkerend",
        "oneTime": "Eén Date"
      },
      "billingPeriod": {
        "monthly": "Maandelijks",
        "annually": "Jaarlijks",
        "weekly": "Wekelijks",
        "daily": "Dagelijks"
      },
      "ariaLabels": {
        "freeMembership": "Keuzerondje gratis lidmaatschap",
        "paidMembership": "Keuzerondje betaald abonnement"
      }
    },
    "menuOptions": {
      "details": "Details",
      "subscriptions": "Subscription",
      "branding": "Branding",
      "themes": "Thema's",
      "tabsConfiguration": "Tabbladen weergeven/verbergen",
      "membershipQuestions": "Vragen over Membership",
      "gamificationAndRewards": "Gamification en beloningen",
      "links": "Left",
      "newsletter": "Nieuwsbrief",
      "reportedContent": "Gerapporteerde Content",
      "discovery": "Ontdekking",
      "import": "Import"
    },
    "newsletter": {
      "title": "Nieuwsbrief",
      "subheading": "Uw Community Digest",
      "frequency": "NieuwsbriefFrequentie",
      "description": "Een Samenvatting van populaire berichten, Ledenactiviteit en gevallen van deze Groep",
      "selectFrequency": "Selecteer frequentie",
      "frequencies": {
        "off": "Uit",
        "daily": "Dagelijks",
        "weekly": "Wekelijks",
        "biweekly": "Tweewekelijks",
        "monthly": "Maandelijks"
      }
    },
    "tabConfiguration": {
      "title": "Tabbladen weergeven/verbergen",
      "description": "Bepaal welke tabbladen in uw community verschijnen. Schakel elk tabblad in of uit om een gerichte en gestroomlijnde ervaring voor uw leden te creëren.",
      "discussionDescription": "Start of neem deel aan gesprekken om updates, ideeën en inzichten met uw community te delen.",
      "learningDescription": "Creëer en beheer cursussen waarmee leden nieuwe vaardigheden of kennis kunnen verwerven.",
      "eventsDescription": "Plan, organiseer en bekijk aankomende sessies, workshops of community-evenementen.",
      "leaderboardDescription": "Erken de best presterende leden en moedig een gezonde betrokkenheid aan via ranglijsten.",
      "membersDescription": "Beheer alle leden en rollen. Dit tabblad blijft zichtbaar voor beheerders, zelfs als het is uitgeschakeld, zodat ledenbeheer altijd toegankelijk blijft.",
      "aboutDescription": "Introduceer het doel, de waarden en de achtergrond van uw community om leden te helpen betrokken te raken.",
      "discussionTooltip": "Discussie is een kernonderdeel van de community en kan niet worden uitgeschakeld",
      "aboutTooltip": "Het tabblad Over is vereist om essentiële informatie over de community te verstrekken en kan niet worden uitgeschakeld."
    },
    "groupSettings": {
      "groupSettings": "Group Settings",
      "changeGroupType": "Change Group Type",
      "changeGroupTypeDescriptionPrivateToPublic": "Dynamic to a Public Group betekent dat every Lopend Requests automatisch wordt Accepted en de Content voor het publiek zichtbaar wordt. Doorgaan?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dynamic to a Private Group betekent new Members Approval nodig en Content blijft Hidden totdat ze zijn Accepted. Doorgaan?",
      "changeGroupTypeConfirmation": "Weet You zeker dat You het Type Group wilt Change ?",
      "changeGroupTheme": "The Theme Change",
      "changeGroupThemeDescription": "Hierdoor wordt het Theme Change voor every the Group Members. Weet You zeker dat You het Theme Group wilt Change ?",
      "updatedGroupDetails": "DetailsUpdated",
      "unableToSaveDetails": "Oops ! Kan Details niet Archive .",
      "groupNameIsRequired": "Group is Required",
      "groupDescriptionIsRequired": "Description Group is Required",
      "groupSlugIsRequired": "Group Slug is Required",
      "groupSlugMustContainOnly": "Group Slug mag alleen Lowercase , Aantal en koppeltekens bevatten",
      "groupSlugAlreadyExists": "Group Slug bestaat al. Gebruik een andere Slug , want deze is al in gebruik",
      "groupSlugRestricted": "Deze slug komt overeen met een van onze beperkte zoekwoorden voor communitylinks. Gebruik een andere slug",
      "pleaseTryAgainLater": "Try again het later opnieuw",
      "unsavedChangesMessage": "You hebt Group Slug Dynamic niet-opgeslagen, weet You zeker dat You deze Undo ?"
    },
    "import": {
      "header": "Skool Group Members Import en hun Content",
      "credentialDescription": "Voer je Skool Certificate in om je Group en hun Content te Import",
      "csvUploadDescription": ".csv . Select File Import From Skool",
      "loginFailed": "You hebt een Invalid Email of password ingevoerd. Try again.",
      "proceedWithImport": "Continue met Import?",
      "iAgree": "Ik ben het ermee eens",
      "importTerms": "Via op 'Ik ga akkoord' te klikken, bevestig en erken You dat You ons hebt ingeschakeld als een onafhankelijke Deal om Services On u uit te voeren (\"Services\"). De Services of bepaalde gegevens, Details , Content en intellectuele Properties van Other Content (\"Info\") From een Issued Platform- Account naar een Received Platform- Account. You verklaart en garandeert dat (i) You de rechtmatige Owner of de Info in het Issued Platform Account bent, (ii) You de Permissions hebt om ons Access te geven tot de Account van het Issued Platform voor de Intent of het uitvoeren van de Services, en (iii) Over ons zal de Transfer of de Info geen inbreuk maken op de intellectuele Properties van de Permissions van een derde partij. You gaat ermee akkoord om ons te vrijwaren, te verdedigen en Hold voor claims van derden die voortkomen Result uw of of de bovenstaande vertegenwoordigers en garanties.",
      "pleaseDownloadCSV": "Download het .CSV File",
      "step01": "Stap 01-",
      "step02": "Stap 02-",
      "uploadCSV": "Upload je .CSV",
      "step01Description": "in werk alle ontbrekende Details voor Group bij , zoals Gmail, voornaam enz. Fill ervoor dat de CSV is geüpload in",
      "thisTemplate": "deze Template",
      "importCSV": ".CSV Import",
      "reSyncData": "Synchroniseer uw gegevens Before .",
      "refreshUserList": "Operator List vernieuwen",
      "reSyncDataDescription": "in de loop der tijd worden If new Operator toegevoegd, raden wij You aan je List te vernieuwen en de CSV Download .",
      "pleaseDontChangeProfileSlug": "Change Profile Slug niet.",
      "selectFile": "File Select",
      "changeFile": "File Change",
      "importMembersFailedText": "Dit kan komen doordat er een Email Address. Check Mark your Import File en Try again met een geldig Email voor deze Members.",
      "upload": "Uploaden",
      "tryAgain": "Opnieuw proberen",
      "syncAllPosts": "Sync every je Share en reactie",
      "membersCouldNotBeAdded": "Members kunnen niet worden toegevoegd aan de Group.",
      "importMembersSuccess": "We hebben een Email sent naar every Individual Group Members, om hun Membership in de Group te bevestigen en te voorzien van de Details . Dit helpt ervoor te zorgen dat every Members op de hoogte is en effectief Access heeft bij de Group .",
      "importMembersAdded": "Members zijn toegevoegd aan de Group",
      "postsNotSynced": "De resterende berichten kunnen niet worden Sync met de Group. Dit kan komen doordat de Share Authors niet succesvol zijn geïmporteerd.",
      "migrationFailed": "Migratie mislukt. Try again.",
      "migrationCompleted": "Migratie Done!",
      "migrationInProgress": "Migratie bezig",
      "createProfile": "Profiel aanmaken",
      "enterCredentials": "Inloggegevens invoeren",
      "uploadingInProgress": "Upload in uitgevoerd!",
      "listMembers": "List Members",
      "downloaded": "Download",
      "uploaded": "geüpload",
      "listPostsDownloaded": "List of Posts is Download.",
      "listPostsDownloading": "List of posts wordt Download.",
      "posts": "posts",
      "members": "Members",
      "imported": "geïmporteerd",
      "step1": "Stap 1:",
      "step2": "Stap 2:",
      "step1Description": "Create een Members aan in Skool Group.",
      "step1Description2": "(inclusief naam, Email Id wachtwoord)",
      "step2Description": "Skool Members Certificate invoeren",
      "skoolUrlPlaceholder": "De groeps-URL van uw Skool invoeren",
      "emailPlaceholder": "Voer het Email Idje Skool in",
      "emailTooltip": "Voer de Email met je Skool- Account in",
      "passwordPlaceholder": "Voer het wachtwoord van je Skool in",
      "confirm": "Bevestigen",
      "validation": {
        "skoolUrl": "Voer een geldige Skool URL",
        "email": "Email is Required",
        "password": "Wachtwoord is Required"
      }
    },
    "approved": "Goedgekeurd",
    "pending": "In afwachting",
    "rejected": "Geweigerd"
  },
  "invitations": {
    "intent": "Help deze community te groeien!",
    "cancelInvitation": "Uitnodiging annuleren",
    "inviteMembers": "Nodig leden uit om bij te dragen aan deze community.",
    "inviteLink": "Uitnodigingslink",
    "invitationLink": "Uitnodigingslink",
    "buildYourCommunity": "Bouw aan uw community!",
    "inviteMembersToCollaborate": "U heeft een nieuwe community gemaakt! Nodig leden uit om bij te dragen aan deze community.",
    "invite": "Uitnodiging",
    "basicInformation": "Basisgegevens",
    "permissions": "Machtigingen"
  },
  "createPost": {
    "title": "Nieuwe blogpost aanmaken",
    "placeholder": "Waar denkt u aan?",
    "liveStream": "Livestream",
    "slug": "URL-slug van blogpost",
    "titleHelp": "De titel, beschrijving en afbeelding worden gebruikt voor de SEO-metatag",
    "nameLabel": "Titel van blogpost",
    "nameValidation": "Titel is vereist",
    "descriptionLabel": "Beschrijving van het bericht",
    "descriptionHelp": "Geef een korte omschrijving, zodat kijkers een idee krijgen van het bericht. Gebruik bij voorkeur tussen de 100 en 250 tekens",
    "descriptionValidation": "Beschrijving is vereist",
    "createLabel": "Post aanmaken",
    "image": "Afbeelding bij blogpost",
    "imageDescription": "De aanbevolen grootte is 600 x 400 px",
    "notificationTitle": "Blogpost aangemaakt",
    "notificationErrorTitle": "Het is niet gelukt om een blogpost aan te maken",
    "postingIn": "Posten in",
    "editingIn": "Bewerken in"
  },
  "post": {
    "downloadRecording": "Download opname",
    "deletePost": "Post verwijderen",
    "reportPost": "Post rapporteren",
    "editPost": "Post bewerken",
    "createPost": "Post maken",
    "publish": "Posten",
    "publishPost": "Post publiceren",
    "addChannel": "Kanaal toevoegen",
    "selectChannel": "Selecteer een kanaal",
    "addLink": "Link toevoegen",
    "removeLink": "Link verwijderen",
    "update": "Updaten",
    "unsavedChanges": "U heeft niet-opgeslagen wijzigingen",
    "unsavedChangesMessage": "Uw niet-opgeslagen wijzigingen gaan verloren. Wilt u nog steeds doorgaan?",
    "unpinFromChannel": "Losmaken",
    "unpinFromHome": "Losmaken",
    "deletePostConfirmation": "Weet u zeker dat u deze post wilt verwijderen?",
    "reportPostConfirmation": "Weet u zeker dat u deze post wilt rapporteren?",
    "postNotFound": "Post niet gevonden",
    "postNotFoundMessage": "De post die u probeert te bekijken, is verwijderd of bestaat niet.",
    "loadMoreComments": "Meer opmerkingen laden",
    "channelNotFound": "Kanaal niet gevonden",
    "isCurrentlyLive": "is nu live",
    "isStartingNow": "begint nu",
    "isHappeningInMinutes": "vindt plaats over {minutes} minuten",
    "isHappeningInHours": "vindt plaats in {hours} hour | vindt plaats in {hours} hour",
    "publicChannel": "Openbaar kanaal",
    "privateChannel": "Privé kanaal",
    "featured": "Uitgelicht",
    "featuredAbout": "Over uitgelicht",
    "noPostsFound": "Geen posts gevonden",
    "pinInfo": "U kunt items, zoals posts, regels en hashtags, vastpinnen. Dan worden ze bovenaan de groep weergegeven.",
    "pinInfoEveryone": "Iedereen in de groep kan deze items zien.",
    "pinInfoRemainVisible": "Vastgepinde items blijven zichtbaar tot u ze losmaakt.",
    "pinInfoNewestItem": "Wanneer u items vastpint, verschijnt het nieuwste item bovenaan de lijst.",
    "onlyVisibleToAdmins": "Alleen zichtbaar voor beheerders",
    "featuredAboutDescription": "Uw beheerders hebben deze items vastgepind, zodat de groep ze kan zien.",
    "channelNotFoundMessage": "U bent geen lid meer van het kanaal die u probeert te openen of het kanaal is verwijderd.",
    "notifications": {
      "unpinned": "Losgemaakt!",
      "pinned": "Vastgezet!",
      "reported": "Post is gerapporteerd!",
      "error": "Er is iets misgegaan!",
      "isCommentDisabled": "Feedback Uitgeschakeld!",
      "isCommentEnabled": "Feedback ingeschakeld!"
    },
    "movePostToChannel": "Move naar Kanaal",
    "pin": "Vastzetten",
    "pinToHome": "Vastmaken op startpagina",
    "pinToChannel": "Vastmaken op kanaal",
    "whatIsYourTitle": "Wat is je Title?",
    "postMovedToChannel": "Share verplaatst naar {channelName} kanaal",
    "upcomingEvent": "Komende gebeurtenis",
    "turnOffCommenting": "Uitschakelen commentaar",
    "enableComments": "Opmerkingen Inschakelen",
    "disableComments": "Feedback uitschakelen",
    "moveToPrivateChannelConfirmation": {
      "title": "Verplaatsen naar privékanaal",
      "message": "U staat op het punt dit bericht over te zetten naar een privékanaal. Alleen leden van dat privékanaal zullen het kunnen zien. Wilt u doorgaan?"
    },
    "onlyAdminsCanPost": "Alleen community beheerders kunnen berichten delen in dit platform."
  },
  "reaction": {
    "noLikes": "Geen vind-ik-leuks",
    "andOthers": "en {count} anderen"
  },
  "UIConfirmation": {
    "privateGroup": "Deze groep is privé",
    "privateGroupMessage": "U moet lid zijn van deze groep om toegang te krijgen tot groepsspecifieke informatie. Vraag toegang aan door op de knop Lid worden van groep te klikken."
  },
  "notifications": {
    "noNotificationsYet": "Nog geen meldingen",
    "whenYouGetNotifications": "Wanneer u meldingen ontvangt, worden ze hier weergegeven",
    "markAllAsRead": "Alles als gelezen markeren",
    "notifications": "Meldingen",
    "all": "Alle",
    "unread": "Ongelezen",
    "checkNotifications": "Inloggen om meldingen te bekijken",
    "noNotifications": "Geen meldingen!",
    "redirectedFromOldSlug": {
      "title": "U bent doorgestuurd naar de bijgewerkte communitylink",
      "content": "Dit is gedaan om de SEO-prestaties voor deze community te verbeteren. Vernieuwen uw bladwijzers met deze nieuwe URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wahoo! 🎉 Verzoek is succesvol verzonden",
    "reviewRequestSoon": "De beheerders van onze groep zullen uw verzoek binnenkort beoordelen. Nog even geduld, we laten het u weten zodra uw lidmaatschap is goedgekeurd.",
    "nonMemberMessage": "U moet lid zijn van deze groep om posts leuk te vinden en erop te reageren",
    "subscribeFor": "Abonneren op",
    "joinGroup": "LID WORDEN VAN DE GROEP",
    "membershipPending": "In afwachting",
    "viewMembershipAnswers": "Membership View",
    "requested": "Aangevraagd",
    "dayFreeTrial": "dag(en) gratis op proef",
    "notPartOfGroup": "Je maakt nog geen deel uit of deze Group , je Membership Requests is in Review. Zodra de Admin uw Requests Accepted, zullen wij You op de hoogte stellen",
    "pleaseAnswerMembershipQuestions": "Beantwoord de vragen van de Membership om join aan deze Group",
    "answerQuestions": "Lidmaatschapsvragen beantwoorden"
  },
  "userProfilePopover": {
    "active": "Actief",
    "longAgo": "lang geleden",
    "chatDisabled": "Deze gebruiker heeft de chat uitgeschakeld",
    "pointsToLevelUp": "punten om een hoger niveau te bereiken",
    "profile": "Profiel",
    "deletedUser": "Gebruiker verwijderd",
    "joined": "Lid geworden",
    "contributions": "Bijdragen"
  },
  "courses": {
    "by": "Door",
    "free": "Gratis",
    "unknownInstructor": "Onbekende Instructeur",
    "courseRestricted": "Deze Route is Privé",
    "courseDeleted": "Deze cursus is verwijderd",
    "noMatchingCourseFound": "Geen overeenkomende cursus gevonden",
    "addCourse": "Cursus toevoegen",
    "updateCourse": "Cursus bijwerken",
    "access": "Alle leden hebben toegang",
    "unableToAddCourse": "Oeps! Kan cursus niet toevoegen",
    "pleaseTryAgainLater": "Probeer het later opnieuw",
    "paymentIntegrationMissing": "Oeps! Betalingsintegratie ontbreekt",
    "paymentIntegrationMissingMessage": "Integreer betalingen op de locatie om betaalde cursussen in te schakelen",
    "course": "Cursus",
    "courseInThisGroup": "een bestaande cursus in deze groep",
    "courseLinkCopied": "Cursuslink gekopieerd!",
    "buyNow": "NU KOPEN",
    "locked": "VERGRENDELD",
    "buyCourse": "CURSUS KOPEN",
    "open": "OPEN",
    "moveCard": "Verplaats kaart",
    "courseViewMessage": "U moet lid zijn van deze groep om de cursussen te kunnen bekijken.",
    "deleteCourse": "Cursus verwijderen",
    "deleteCourseConfirmation": "Weet u zeker dat u deze cursus wilt verwijderen?",
    "courseAccessNotGranted": "Geen toegang tot cursus verleend",
    "courseAccessNotGrantedMessage": "We zijn bezig om u toegang te verlenen tot de cursus. Vernieuw de pagina en probeer het later opnieuw.",
    "autoRenewsAfter": "Wordt automatisch vernieuwd na",
    "oneTimePayment": "Eenmalige betaling",
    "emptyCoursesMessage": "Ziet eruit als een spookstad. Hier is niets te zien",
    "updatedSuccessfully": "Succesvol Updated",
    "addedSuccessfully": "Cursus toegevoegd",
    "createCourse": "Nieuwe cursus maken",
    "emptyCourseLibrary": "Uw cursusbibliotheek is leeg!",
    "createdOutsideGokollabMessage": "Deze community is buiten Gokollab gecreëerd en vindbaar gemaakt. Om nieuwe cursussen aan te maken, logt u alstublieft in op de community vanaf het bronplatform",
    "createCourseOnGokollabMessage": "Aanmaken een nieuw Route op Gokollab om deze Maken beschikbaar te stellen aan uw communityLeden.",
    "or": "of",
    "createNewOne": "een nieuwe maken",
    "labels": {
      "selectCourse": "Cursus selecteren",
      "courseVisibility": "Zichtbaarheid cursus",
      "courseAccess": "Toegang tot cursus",
      "coursePrice": "Prijs van de cursus",
      "subscriptionType": "Abonnementstype",
      "billingPeriod": "Factureringsperiode",
      "testMode": "Testmodus",
      "turnOnTestPayments": "Testbetalingen inschakelen met een testkaart",
      "currency": "Valuta",
      "trialDays": "Proefdagen",
      "recurring": "Terugkerend",
      "free": "Gratis",
      "oneTime": "Eén Date",
      "refresh": "Vernieuwen",
      "accessStartsAtDay": "Access begint op Day",
      "maximumYouCanEnterIs365": "Max . You dat kan invoeren is 365",
      "allMembers": "every Members",
      "levelUnlock": "Even",
      "buyNow": "now kopen",
      "timeUnlock": "Date vrijgeven",
      "gamificationLevel": "Even Gamification",
      "privateChannel": "Privé kanaal",
      "private": "Privé",
      "marketingChannel": "Marketing",
      "selectCurrency": "Selecteer een valuta"
    },
    "placeholders": {
      "enterPrice": "Prijs invoeren",
      "enterTrialDays": "Proefdagen invoeren",
      "selectCurrency": "Selecteer één optie",
      "selectBillingPeriod": "Selecteer één optie",
      "billingPeriod": "Factureringsperiode selecteren"
    },
    "validations": {
      "validPrice": "Geldige prijs invoeren",
      "required": "Selecteer een cursus",
      "validMembershipPrice": "Voer een geldige lidmaatschapsprijs in",
      "validTrialDays": "Voer een geldig aantal proefdagen in",
      "requiredSubscriptionType": "Selecteer het abonnementstype",
      "courseVisibility": "Please Select Course Visibility",
      "requiredGamificationLevel": "Select Gamification Even",
      "requiredPrivateChannel": "Select het Private kanaal",
      "validAccessStartDay": "Voer een Access Start Start Day in"
    },
    "descriptions": {
      "buyNowDescription": "Deze cursus is Public bij aankoop",
      "timeUnlockDescription": "Members ontsluiten After X dagen",
      "levelUnlockDescription": "Alleen Members en een bepaalde Even kunnen worden ontgrendeld",
      "allMembersDescription": "every Members Access to deze cursus",
      "privateChannelDescription": "Members of a Private kanaal",
      "privateDescription": "Toegang alleen verleend door admin"
    },
    "helperText": {
      "levelBased": "Op niveau",
      "timeLimited": "hour-Limited",
      "privateBased": "Privé",
      "free": "Gratis",
      "levelAvailableAt": "Beschikbaar voor Even 0{value}",
      "timeLimitedAfterJoining": "Public {value} {day} After lid worden van de Group",
      "day": "Day",
      "days": "dagen",
      "purchaseToUnlockAccess": "Koop deze cursus om Access",
      "privateCourse": "Privécursus - Toegang alleen verleend door de admin",
      "locked": "Deze cursus is gesloten",
      "unlockAtLevel": "Deze cursus wordt ontgrendeld bij Even {level}",
      "unlockAfterDays": "Deze cursus ontgrendelt After {days} {dayText}",
      "privateChannelBased": "Op basis van kanalen Private",
      "externalAccess": "Andere Groep/Aanbod"
    },
    "manageAccess": {
      "manageCourses": "Beheer Cursussen",
      "revokeCourseAccess": "Beheer Cursussen",
      "grantCoursesAccess": "Toegang cursussen verlenen",
      "removeAccess": "Toegang verwijderen",
      "grantAccess": "Verleen toegang",
      "grant": "Verlenen",
      "clear": "Wissen",
      "selectAll": "Alles selecteren",
      "revokeAccessConfirmTitle": "Wilt u de toegang tot de cursus verwijderen?",
      "revokeAccessConfirmMessage": "Weet u zeker dat u de toegang tot \"{courseName}\" voor {userName} wilt verwijderen?",
      "externalAccessTooltip": "Kan niet verwijderen: de gebruiker heeft toegang vanuit een andere groep of aanbod.",
      "cannotRevokeAutoAccess": "Kan niet worden verwijderd: toegang wordt automatisch verleend op basis van cursusinstellingen (betaald, niveau, tijd of gratis).",
      "searchPlaceholder": "Zoek naar cursussen",
      "noCoursesFound": "Geen cursussen gevonden",
      "noCoursesSelected": "Er zijn nog geen cursussen geselecteerd.",
      "noCoursesAvailable": "Er zijn geen cursussen beschikbaar om toe te wijzen.",
      "noSearchResults": "Geen zoekresultaten",
      "failedToLoadCourses": "Cursussen laden mislukt",
      "accessRevoked": "Toegang cursus succesvol verwijderd",
      "failedToRevokeAccess": "Kon de toegang tot de cursus niet verwijderen",
      "accessGranted": "Toegang tot de cursus succesvol verleend",
      "multipleAccessGranted": "{count} cursussen succesvol toegekend",
      "failedToGrantAccess": "Kon geen toegang tot de cursus verlenen"
    },
    "ariaLabels": {
      "courseCard": "Kaart cursus",
      "courseCardActions": "Acties cursuskaarten",
      "editCourse": "Cursus bewerken",
      "deleteCourse": "Cursus verwijderen",
      "moveCard": "Verplaats kaart",
      "copyLink": "Link kopiëren",
      "cardImage": "Afbeelding cursuskaart"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Fout bij het uploaden van bestand"
    },
    "uploadLinkVideo": "Video uploaden/koppelen",
    "removeMedia": "Verwijder {fileName} Media"
  },
  "leaderboard": {
    "level": "Niveau",
    "lastUpdated": "Laatst bijgewerkt",
    "members": "Leden",
    "percentOfMembers": "{percentage}% van de leden",
    "rewards": "Beloningen",
    "allTime": "Altijd",
    "pointsToLevelUp": "punten om een hoger niveau te bereiken",
    "points": "Punten",
    "leaderboard7d": "Leaderboard (7 dagen)",
    "leaderboard30d": "Leaderboard (30 dagen)",
    "leaderboardAlltime": "Leaderboard (totaaloverzicht)",
    "yourRank": "Jouw positie",
    "noActivityToShow": "Geen activiteit om te tonen",
    "rewardsWillBeDisplayedHere": "Beloningen worden hier weergegeven",
    "seeAllLeaderboards": "Bekijk alle leaderboards",
    "addRewards": "Beloningen toevoegen",
    "howPointsWork": "U verdient punten wanneer andere leden uw posts of comments leuk vinden. 1 vind ik leuk = 1 punt. Dit moedigt gebruikers aan om content van goede kwaliteit te maken en te interacteren met andere leden in de community.",
    "levels": "Niveaus",
    "levelsDescription": "Als u punten verdient, stijgt uw niveau. U niveau wordt onderin weergegeven, rechts van uw avatar. Het aantal punten dat nodig is om naar het volgende niveau te gaan, wordt weergegeven in de voortgangsbalk op het Leaderboard.",
    "pointsAndLevels": "Points & Layers"
  },
  "events": {
    "createEvent": "Gebeurtenis aanmaken",
    "dragAndDrop": "Een SVG, PNG, JPG of GIF slepen en neerzetten (max. 800 x 400px)",
    "editEvent": "Gebeurtenis bewerken",
    "addEvent": "Gebeurtenis toevoegen",
    "paymentDetails": "Betalingsgegevens",
    "event": "Gebeurtenis",
    "goBack": "Teruggaan",
    "cancelEdit": "Bewerken annuleren",
    "cancelEvent": "Gebeurtenis annuleren",
    "next": "Volgende",
    "saveEvent": "Gebeurtenis opslaan",
    "editRecurringEvent": "Terugkerende gebeurtenis bewerken",
    "thisEvent": "Deze gebeurtenis",
    "thisAndFollowingEvents": "Deze en volgende gebeurtenissen",
    "ok": "Oké",
    "deleteRecurringEvent": "Terugkerende gebeurtenis verwijderen",
    "allEvents": "Alle gebeurtenissen",
    "adminsFreeForPaidEvents": " * Admins kunnen zich registreren voor Paid contracten voor Free",
    "deleteEvent": "Gebeurtenis verwijderen",
    "onceEventDeleted": "Verwijderde gebeurtenissen worden niet in uw kalender weergegeven.",
    "toRegister": "om in te schrijven",
    "calendar": "Kalender",
    "addToCalendar": "Toevoegen aan kalender",
    "declineRegistration": "Afwijzen",
    "paymentFailedMessage": "Uw betaling is mislukt vanwege een aantal onvoorziene omstandigheden! Probeer het later opnieuw.",
    "upcoming": "Aankomend",
    "noMoreEvents": "Geen gebeurtenissen om te tonen",
    "joinGroupToRegister": "U moet lid zijn van deze groep om u voor deze gebeurtenis te kunnen inschrijven",
    "past": "Verleden",
    "youHaveRegisteredForOneEvent": "U hebt zich aangemeld voor 1 gebeurtenis. We sturen u een dag voor elke gebeurtenis een herinnering.",
    "upcomingEvents": "Komende gebeurtenissen",
    "noUpcomingEvents": "Geen aankomende gebeurtenissen",
    "pastEvents": "Afgelopen gebeurtenissen",
    "noPastEvents": "Geen afgelopen gebeurtenissen",
    "noMatchingEventFound": "Geen overeenkomend gebeurtenis gevonden",
    "week": "Week",
    "month": "Maand",
    "today": "Vandaag",
    "registrationConfirmed": "Registratie Confirmed voor {event}.",
    "eventDeletedOrRestricted": "Gebeurtenis is Verwijderd of Privé",
    "eventDeleted": "Uw gebeurtenis is verwijderd",
    "eventRestricted": "U heeft geen toegang tot deze gebeurtenis",
    "validations": {
      "titleValidation": "Titel is vereist",
      "colorValidation": "Kleur is vereist",
      "startTimeValidation": "Starttijd is vereist",
      "endTimeValidation": "Eindtijd is vereist",
      "endTimeAfterStartTime": "De eindtijd moet na de starttijd liggen",
      "startTimeMustBeInFuture": "Starttijd moet in de toekomst liggen",
      "locationValidation": "Locatie is vereist",
      "locationValidationMobile": "Locatie is vereist",
      "locationUrlValidation": "Een geldige locatie-URL is vereist",
      "descriptionValidation": "Beschrijving is vereist",
      "descriptionValidationMaxLength": "De beschrijving mag niet langer zijn dan 300 tekens",
      "recaptchaError": "Verificatie mislukt! Probeer het opnieuw",
      "repeatIntervalValidation": "Frequentie is vereist",
      "repeatIntervalValidator": "Herhaalinterval moet dag, week, maand of jaar zijn",
      "repeatIntervalRequired": "Herhaalinterval is vereist",
      "repeatOccurrenceValidator": "Herhaalfrequentie moet groter zijn dan 0",
      "repeatOccurrenceRequired": "Herhaalfrequenti is vereist",
      "invalidDateFormat": "Ongeldig datumformaat",
      "endDateMustBeAfterStartDate": "De einddatum van het gebeurtenis moet na de begindatum liggen",
      "recurringEndDateValidation": "Een terugkerende einddatum is vereist",
      "repeatsOnValidation": "Selecteer minimaal één dag",
      "invalidDaySelection": "Ongeldige dag geselecteerd",
      "endOptionRequired": "Eindoptie is vereist",
      "levelValidation": "Selecteer een niveau",
      "courseValidation": "Selecteer een cursus",
      "channelValidation": "Selecteer een kanaal",
      "eventPriceValidation": "De Price is Required en moet groter zijn dan {min}"
    },
    "placeholders": {
      "selectStartTime": "Starttijd selecteren",
      "selectEndTime": "Eindtijd selecteren",
      "selectLocation": "Locatie selecteren",
      "locationUrl": "Link/adres",
      "description": "Beschrijving",
      "selectRecurringEndDate": "Selecteer terugkerende einddatum",
      "selectDate": "Datum selecteren",
      "event": "Gebeurtenis",
      "selectColor": "Selecteer een kleur",
      "selectAttendees": "Selecteer deelnemers",
      "selectPrivateChannel": "Privékanaal selecteren",
      "selectCourse": "Cursus selecteren",
      "selectLevels": "Selecteer niveaus",
      "selectCalendar": "Kalender selecteren"
    },
    "labels": {
      "startTime": "Begintijd",
      "endTime": "Eindtijd",
      "others": "Overige",
      "oneTimePriceForEventRegistration": "eenmalige prijs voor registratie voor de gebeurtenis.",
      "totalAmount": "Totaalbedrag",
      "cardAuthorizationText": "Door uw kaartgegevens te verstrekken, staat u toe dat {locationName} het bedrag op de creditcard in rekening brengt voor toekomstige betalingen overeenkomstig hun voorwaarden.",
      "secureAndSafePayments": "100% veilige en betrouwbare betalingen",
      "day": "Dag",
      "week": "Week",
      "month": "Maand",
      "year": "Jaar",
      "recurringEvent": "Wordt dit een terugkerende gebeurtenis?",
      "repeatsEvery": "Herhaalt elke",
      "repeatsOn": "Herhaalt op",
      "end": "Einde",
      "ends": "Close",
      "neverEnds": "Eindigt nooit",
      "orange": "Oranje",
      "red": "Rood",
      "blue": "Blauw",
      "green": "Groen",
      "violet": "Violet",
      "purple": "Paars",
      "yellow": "Geel",
      "title": "Titel",
      "color": "Kleur",
      "allMembers": "Alle leden",
      "membersAtALevel": "Leden op een bepaald niveau",
      "membersOfACourse": "Leden van een cursus",
      "membersOfAPrivateChannel": "Leden van een privékanaal",
      "whoCanAttendTheEvent": "Wie kan de gebeurtenis bijwonen?",
      "channel": "Kanaal",
      "course": "Cursus",
      "level": "Niveau",
      "remindAttendeesByEmail": "Herinner Before 1 Day Via Email",
      "hideLocationFromNonAttendees": "Locatie verbergen voor niet-deelnemers.",
      "addChargesToTheEvent": "Add op Event",
      "noPaymentRequired": "Geen betaling Required",
      "location": "Locatie",
      "link": "Link",
      "description": "Beschrijving",
      "timezone": "Tijdzone",
      "eventType": "Type gebeurtenis",
      "eventTypeChangeWarning": "Dynamic to Event Type Of pricing zal Apply op every occurrences in de serie.",
      "never": "Nooit",
      "on": "Aan",
      "after": "Na",
      "occurrences": "occurrences",
      "selectEventEnd": "Select When the Event zal End.",
      "turnOnTestPayments": "On Flip Via een Test",
      "pay": "Betalen",
      "hideAttendees": "Deelnemers Hide From Group Members",
      "guests": "{count} gasten",
      "guestList": "Guest List",
      "noAttendees": "Nog geen deelnemers",
      "viewAttendees": "Deelnemers View",
      "exportAttendees": "Deelnemers Export"
    },
    "notifications": {
      "eventCreated": "Event Created!",
      "eventUpdated": "succesvol Updated !",
      "eventCreationFailed": "Aanmaken zoals Event mislukt!",
      "eventUpdateFailed": "Updaten Event !",
      "eventDeleted": "Gebeurtenis succesvol verwijderd!",
      "eventDeletionFailed": "Het verwijderen van de gebeurtenis is mislukt!",
      "paymentFailed": "Betaling mislukt!",
      "registrationSuccessful": "Registratie succesvol!",
      "registrationFailed": "Registratie mislukt!",
      "addToCalendarFailed": "Gebeurtenis aan kalender toevoegen mislukt!",
      "locationDetailsCopied": "Locatiegegevens zijn naar het klembord gekopieerd!",
      "registrationDeclined": "Registratie succesvol geweigerd!",
      "registrationDeclinedFailed": "Registratie weigeren is mislukt!",
      "fetchAttendeesFailed": "Het laden van deelnemers is mislukt",
      "emailCopied": "Email Copied naar klembord",
      "exportAttendeesFailed": "Kan deelnemers niet exporteren"
    },
    "selectCalendar": "Selecteer een kalender",
    "eventImage": "Afbeelding gebeurtenis",
    "errorLoadingEvent": "Fout bij het laden gebeurtenis"
  },
  "login": {
    "invite": "nodigde u uit om lid te worden van"
  },
  "contentReports": {
    "contentDeleted": "Content is verwijderd!",
    "noActionTaken": "Er is geen actie ondernomen n.a.v. de gerapporteerde content!",
    "reportedContentNotFound": "Gerapporteerde content niet gevonden. Mogelijk is er al actie ondernomen.",
    "reported": "Gerapporteerd",
    "viewAllReportedContentHere": "U kunt hier alle gerapporteerde content bekijken",
    "takeActionOnReportedContent": "Onderneem actie op gerapporteerde content",
    "andOthers": "en {count} anderen",
    "reportedThisPost": "deze post is gerapporteerd",
    "keep": "HOUDEN",
    "remove": "VERWIJDEREN",
    "deleteContent": "Content verwijderen",
    "deleteConfirmation": "Weet u zeker dat u deze content wilt verwijderen?",
    "noMemberReportedContent": "Geen door leden gemelde content",
    "whenMembersReportPostsOrComments": "Wanneer leden posts of opmerkingen melden, verschijnen ze hier zodat u ze kunt beoordelen. U kunt ze behouden of verwijderen, u kunt ook de leden die ze hebben geplaatst pauzeren, verwijderen of blokkeren.",
    "reportedThisComment": "U heeft deze opmerking gemeld."
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Deze content is momenteel niet beschikbaar",
    "whenThisHappens": "Dit komt meestal doordat de eigenaar de content alleen heeft gedeeld met een kleine groep mensen, heeft aangepast wie het kan zien of de content is verwijderd."
  },
  "search": {
    "noResultsFor": "0 resultaten voor \"{query}\" in de community",
    "noResultsFound": "Geen resultaten gevonden"
  },
  "noCommunities": {
    "noCommunitiesFound": "Geen gemeenschappen gevonden",
    "startCreatingYourOwnCommunities": "Begin door uw eigen communities te maken en uw publiek erbij te betrekken!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Niet toegetreden tot een",
      "communities": "Community's",
      "yet": "Nog"
    },
    "noCommunitiesFoundGokollabDescription": "Ontdek ruimten waar mensen ideeën delen, elkaar ondersteunen en samen groeien."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Niet ingeschreven in een",
      "course": "Cursus",
      "yet": "Nog"
    },
    "noCoursesFoundGokollabDescription": "Verken impactvolle cursussen die ontworpen zijn om u te helpen leren, verbeteren en slagen."
  },
  "notFound": {
    "ohNo": "oh nee ...",
    "weHaveHadAnError": "Er is een fout opgetreden",
    "error404": "Fout 404",
    "sorryPleaseCheckBack": "Sorry ... kom zo nog eens terug."
  },
  "time": {
    "justNow": "Alleen nu",
    "timeAgo": "{value}{unit} geleden",
    "timeAgoFull": "{value} {unit} geleden",
    "units": {
      "year": "j",
      "years": "jaar",
      "month": "mnd",
      "months": "maanden",
      "week": "wk",
      "weeks": "weken",
      "day": "d",
      "days": "dagen",
      "hour": "u",
      "hours": "uur",
      "minute": "m",
      "minutes": "minuten",
      "second": "s",
      "seconds": "Seconds",
      "monthly": "Maandelijks",
      "weekly": "Wekelijks",
      "annually": "Jaarlijks"
    },
    "dayAbbreviations": {
      "mon": "ma",
      "tue": "di",
      "wed": "wo",
      "thu": "do",
      "fri": "vr",
      "sat": "za",
      "sun": "zo"
    }
  },
  "emojiPicker": {
    "notfound": "Geen emoji gevonden",
    "recent": "Veel gebruikt",
    "smileys": "Smileys en emoticon",
    "people": "Mensen en Body",
    "nature": "Dieren en natuur",
    "foods": "Eten en drinken",
    "activity": "Activiteit",
    "places": "Reizen en Seats",
    "objects": "Objecten",
    "symbols": "Symbolen",
    "flags": "Flags",
    "custom": "Aangepast"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussie",
    "learning": "learning",
    "people": "Mensen"
  },
  "globalUserProfile": {
    "ownedBy": "Eigendom van {name}",
    "memberships": "Lidmaatschappen",
    "membershipsInCommon": "Lidmaatschappen ({count} gemeenschappelijk)",
    "membersCount": "{count} leden",
    "contributions": "{count} bijdragen aan {group}",
    "contributionsFor": "Bijdragen voor",
    "justPosts": "Alleen posts",
    "postAndComments": "Posts en opmerkingen",
    "followSuccess": "U bent begonnen met volgen",
    "unfollowSuccess": "U volgt niet langer"
  },
  "profile": {
    "active": "Actief",
    "ago": "geleden",
    "bio": "Bio"
  },
  "golive": {
    "golive": "Ga live",
    "selectVideoSourceToStart": "Selecteer een videobron om te beginnen met streamen",
    "chooseHowToGoLive": "Kies hoe u live wilt gaan",
    "flipCamera": "Camera omdraaien",
    "participants": "Deelnemers",
    "chats": "Chats",
    "react": "React",
    "raise": "Verbeteren",
    "shareScreen": "Delen",
    "letsCheckYourCamAndMic": "Laten we uw camera en microfoon controleren",
    "hostedBy": "Gehost door",
    "join": "Deelnemen",
    "needCameraPermission": "Camera-machtiging vereist",
    "needMicrophonePermission": "Microfoontoestemming vereist",
    "needSpeakerPermission": "Toestemming spreker vereist",
    "createLiveVideo": "Een live video maken",
    "host": "Host",
    "chooseWhereToPost": "Selecteren waar u wilt posten",
    "whenAreYouGoingLive": "Wanneer gaat u live?",
    "postingIn": "plaatsen in",
    "live": "Live",
    "postDetails": "Details bericht",
    "streamingSoftware": "Streamingsoftware",
    "streamingSoftwareDescription": "U kunt streamingsoftware zoals Zoom, OBS of StreamYard gebruiken om direct uit te zenden. Kopieer eenvoudig de opgegeven URL en code van de stream in de instellingen van uw streamingsoftware. Na configuratie begint u uw uitzending in de software. Deze zal automatisch live streamen naar uw geselecteerde platform.",
    "streamKey": "Streamcode",
    "streamKeyDescription": "Dit kunt u elke keer dat u live gaat opnieuw gebruiken. U kunt slechts één live video tegelijk uitzenden met uw vastgezette streamsleutel.",
    "serverUrl": "Server-URL",
    "serverUrlDescription": "Dit kan in uw streamingapp 'URL' of 'adres' worden genoemd.",
    "selectVideoSource": "Selecteer videobron",
    "copyPasteStreamKey": "Kopieer en plak de streamcode in uw streamingapp.",
    "copyPasteServerUrl": "Kopiëren en plak de server-URL in uw streamingapp.",
    "addPostDetails": "Voeg info toe",
    "enterTitle": "Voer een titel in",
    "notifyMembers": "Stel leden op de hoogte dat u live gaat (stuurt alleen in-app- en pushmeldingen)",
    "notifyMembersMobile": "Breng leden op de hoogte dat u live gaat",
    "meetingRoom": "Vergaderruimte",
    "meetingRoomDescription": "Gebruik de functie Vergaderruimte om live sessies te hosten. Als alle leden hun webcam en microfoon aanzetten kunnen ze live communiceren. Zo wordt een virtuele ruimte gecreëerd vergelijkbaar met Zoom of Google Meet, waarin iedereen elkaar face-to-face kan zien en met elkaar kan praten.",
    "cameraControls": "Camerabediening",
    "cameraControlsTooltip": "Configureer uw camera- en audio-instellingen voordat u live gaat. Zorg ervoor dat uw camera en microfoon correct zijn aangesloten en dat ze de vereiste machtigingen hebben.",
    "selectMediaSource": "Selecteer een mediabron",
    "startScreenShare": "Start scherm delen",
    "stopScreenShare": "Stop scherm delen",
    "wasLive": "was live",
    "isLive": "is live",
    "goingLive": "gaat live",
    "tapToAddDescription": "Tik om een beschrijving toe te voegen...",
    "selectChannel": "Selecteer kanaal",
    "saveAsPost": "Houd livestream als bericht",
    "selectVideoSourceTooltip": "U kunt kiezen tussen streamingapps of webcam wanneer u live gaat:\n\n1. Streamingapps\n   • U krijgt van ons een streamcode en stream-URL.\n   • U moet deze configureren in Zoom, OBS of andere apps van derden die livestreaming ondersteunen.\n\n2. Webcam\n • Ga rechtstreeks live door gebruik te maken van uw camera en microfoon.\n   • Deelnemers kunnen de live stream bekijken en communiceren via de live chat.\n   • Als host kunt u toestemmingen voor de camera of microfoon op elk moment beheren en intrekken.",
    "pleaseSelectCameraMicrophoneSpeaker": "Selecteer camera, microfoon en luidspreker",
    "pleaseStartStreamBeforeGoingLive": "Begin de stream voordat u live gaat",
    "watching": "Bekijken",
    "processingRecording": "Opname wordt verwerkt",
    "recordingFailed": "Opname niet beschikbaar",
    "recordingFailedDescription": "Er is een probleem opgetreden tijdens het verwerken van deze livesessie, en de opname kon niet worden opgeslagen.",
    "streamEndedRecordingWillBeAvailableSoon": "Stroom gesloten. De opname wordt momenteel verwerkt en zal spoedig beschikbaar zijn.",
    "joinStream": "Deelnemen aan stream",
    "recordingInProgress": "Opname bezig",
    "recordingNotAvailable": "Opname mislukt",
    "leaveSession": "Sessie verlaten",
    "endSession": "Sessie beëindigen",
    "rec": "REC",
    "selectCamera": "Selecteer Camera",
    "noCamerasFound": "Geen camera's gevonden",
    "cameraPermissionNeeded": "Cameramachtiging nodig",
    "leave": "Vertrekken",
    "chooseMicCam": "Selecteer Mic/Cam",
    "selectMicrophone": "Microfoon selecteren",
    "selectSpeaker": "Selecteer Spreker",
    "noMicrophonesFound": "Geen microfoons gevonden",
    "noSpeakersFound": "Geen luidsprekers gevonden",
    "microphonePermissionNeeded": "Microfoontoestemming nodig",
    "speakerPermissionNeeded": "Machtiging voor luidsprekers vereist",
    "noParticipantOpenCamOrMic": "Deze vergadering werd niet opgenomen omdat geen enkele van de deelnemers een microfoon of camera had ingeschakeld. Opnames worden alleen gemaakt wanneer ten minste één deelnemer iets doet."
  }
}
